'use strict';

var dateIsValid = require('./dateIsValid');

function assertDateIsValid(d) {
  if (!dateIsValid(d)) {
    throw new TypeError('Date is not valid');
  }
}

module.exports = assertDateIsValid;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/internal/assertDateIsValid.js
// module id = 90
// module chunks = 1